export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: '名称',
      prop: 'circleName',
      solt: true,
      search: true,
      searchPlaceholder: '请输入',
    },
    {
      label: '是否公开',
      prop: 'publicText',
    },
    {
      label: '申请者',
      prop: 'requestedName',
    },
    {
      label: '状态',
      prop: 'statusText',
    },
    {
      label: '申请时间',
      prop: 'requestedTime',
    }
  ]
}

export const statusOptions = [
  {value: 0, label: '待审核'},
  {value: 1, label: '已通过'},
  {value: 2, label: '未通过'}
]
